import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  link: {
    fontWeight: 600,
    fontSize: 16,
    textDecoration: "none",
  },
  iconButton: {
    paddingBottom: 7,
  },
  modalText: {
    wordWrap: "break-word",
    whiteSpace: "normal",
  },
});
export default useStyles;
